import { forwardRef, useEffect } from 'react';
import type { LayoutAPI } from '@elfsight/widget-ui';
import { ListLayout, mapListLayoutSettings } from '@elfsight/widget-ui';
import { useTranslation } from 'react-i18next';
import { useData } from '../../data';
import { useSocialFeedSettings } from '../../utils';
import { useLayout } from '../LayoutProvider';
import { renderPost } from '../utils';

export const List = forwardRef<LayoutAPI, unknown>((_props, forwardingRef) => {
  const settings = useSocialFeedSettings();
  const listSettings = mapListLayoutSettings(settings);
  const { loadMoreButton, postTextColor } = settings;
  const dataSource = useData();
  const { t } = useTranslation();

  const { setRerender } = useLayout();

  useEffect(() => {
    setRerender(undefined);
  }, [setRerender]);

  return (
    <ListLayout
      {...listSettings}
      ref={forwardingRef}
      dataSource={dataSource}
      loaderColor={postTextColor}
      // @ts-expect-error unknown не может применится для типа DataValue
      renderItem={renderPost}
      loadMoreButton={loadMoreButton}
      loadMoreButtonText={t('Load More')}
      withPagination
    />
  );
});
